<div #mainDiv_ll_model_info style="width: 100%; padding: 20px; box-sizing: border-box;">
  <div [style.width.px]="bundle.spW"
       [style.height.px]="bundle.spH"
       style="overflow: auto; box-sizing: border-box;">

    <!-- Model ID Row -->
    <div style="display: flex; align-items: center; margin-bottom: 7px; padding-left: 15px;">
      <span style="display: inline-block; width: 175px; min-width: 175px; padding: 5px; font-weight: 500; font-size: small;">
        LendingLinc Model ID:
      </span>
      <span style="padding: 5px; font-size: small; color: #333;">
        {{ bundle.MODEL?.LOANMODELID || '-' }}
      </span>
    </div>

    <!-- Model Name Row -->
    <div style="display: flex; align-items: center; margin-bottom: 7px; padding-left: 15px;">
      <span style="display: inline-block; width: 175px; min-width: 175px; padding: 5px; font-weight: 500; font-size: small;">
        Model Name:
      </span>
      <input type="text"
             [value]="bundle.MODEL?.MODELNAME || ''"
             (input)="onModelNameChange($event)"
             style="padding: 5px; font-size: small; width: 300px; max-width: 100%;" />
    </div>

    <!-- Model Status Row -->
    <div style="display: flex; align-items: center; margin-bottom: 7px; padding-left: 15px;">
      <span style="display: inline-block; width: 175px; min-width: 175px; padding: 5px; font-weight: 500; font-size: small;">
        Model Status:
      </span>
      <div style="display: flex; align-items: center; gap: 20px; padding: 5px;">
        <label style="display: flex; align-items: center; font-size: small; cursor: pointer;">
          <input type="radio" name="modelStatus"
                 [checked]="bundle.MODEL?.STATUS === 'A'"
                 (change)="onStatusChange('A')"
                 style="margin-right: 6px;" />
          Active
        </label>
        <label style="display: flex; align-items: center; font-size: small; cursor: pointer;">
          <input type="radio" name="modelStatus"
                 [checked]="bundle.MODEL?.STATUS === 'N'"
                 (change)="onStatusChange('N')"
                 style="margin-right: 6px;" />
          Inactive
        </label>
        <label style="display: flex; align-items: center; font-size: small; cursor: pointer;">
          <input type="radio" name="modelStatus"
                 [checked]="bundle.MODEL?.STATUS === 'P'"
                 (change)="onStatusChange('P')"
                 style="margin-right: 6px;" />
          Pending
        </label>
      </div>
    </div>

    <!-- Lender Row -->
    <div style="display: flex; align-items: center; margin-bottom: 7px; padding-left: 15px;">
      <span style="display: inline-block; width: 175px; min-width: 175px; padding: 5px; font-weight: 500; font-size: small;">
        Lender:
      </span>
      <select style="padding: 5px; font-size: small; min-width: 200px;"
              [value]="bundle.MODEL?.LEADLENDERCOMPANYID"
              (change)="onLenderChange($event)">
        <option *ngFor="let lender of bundle.LEAD_LENDERS"
                [value]="lender.COMPANYID"
                [selected]="lender.COMPANYID === bundle.MODEL?.LEADLENDERCOMPANYID">
          {{ lender.COMPANYNAME }}
        </option>
      </select>
    </div>

    <!-- Companies Section (NEW) -->
    <div style="margin-top: 15px; padding-left: 15px;">
      <span style="font-weight: 500; font-size: small; display: block; margin-bottom: 6px;">
        Companies:
      </span>

      <table style="width: 100%; border-collapse: collapse; font-size: small;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="width: 60px; text-align: center; padding: 5px; border: 1px solid #ddd;">Select</th>
            <th style="text-align: left; padding: 5px; border: 1px solid #ddd;">Company Name</th>
            <th style="text-align: left; padding: 5px; border: 1px solid #ddd;">Type</th>
            <th style="width: 120px; text-align: right; padding: 5px; border: 1px solid #ddd;">Percentage</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let company of bundle.COMPANYLIST">
            <td style="text-align: center; padding: 5px; border: 1px solid #ddd;">
              <input type="checkbox"
                     [checked]="company.SELECTED === 'Yes'"
                     (change)="onCompanySelectedChange(company)" />
            </td>
            <td style="padding: 5px; border: 1px solid #ddd;">
              {{ company.COMPANYNAME }}
            </td>
            <td style="padding: 5px; border: 1px solid #ddd;">
              {{ company.COMPANYTYPEDESC }}
            </td>
            <td style="padding: 5px; border: 1px solid #ddd; text-align: right;">
              <input *ngIf="company.SYSTEMCOMPANYTYPEID == 66"
                     type="text"
                     [value]="company.PERCENTAGE"
                     (input)="onCompanyPercentageChange(company, $event)"
                     style="width: 100%; text-align: right; padding: 2px; font-size: small;"
                     placeholder="0" />
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="bundle.COMPANYLIST?.length === 0" style="font-size: small; color: #666; padding: 10px;">
        No companies available.
      </div>
    </div>

    <!-- Products Section -->
    <div style="margin-top: 15px; padding-left: 15px;">
      <span style="font-weight: 500; font-size: small; display: block; margin-bottom: 6px;">
        Products:
      </span>

      <!-- Total Price Row -->
      <div style="text-align: right; padding: 8px 10px; background-color: #f0f0f0; font-weight: bold; font-size: small; border: 1px solid #ddd; margin-bottom: 1px;">
        Total Price: ${{ totalSelectedAmount | number:'1.0-0' }}
      </div>

      <!-- Products Table -->
      <table style="width: 100%; border-collapse: collapse; font-size: small;">
        <thead>
          <tr style="background-color: #f5f5f5;">
            <th style="width: 60px; text-align: center; padding: 5px; border: 1px solid #ddd;">Select</th>
            <th style="text-align: left; padding: 5px; border: 1px solid #ddd;">Product Name</th>
            <th style="width: 180px; text-align: right; padding: 5px; border: 1px solid #ddd;">Price</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of bundle.PRODUCTS">
            <td style="text-align: center; padding: 5px; border: 1px solid #ddd;">
              <input type="checkbox"
                     [checked]="product.SELECTED === true"
                     (change)="onProductSelectedChange(product)" />
            </td>
            <td style="padding: 5px; border: 1px solid #ddd;">
              {{ product.SYSTEMPRODUCTNAME }}
            </td>
            <td style="padding: 5px; border: 1px solid #ddd;">
              <input type="text"
                     [value]="formatPrice(product.SYSTEMPRODUCTPRICE)"
                     (input)="onProductPriceChange(product, $event)"
                     style="width: 100%; text-align: right; padding: 2px; font-size: small;"
                     placeholder="0" />
            </td>
          </tr>
        </tbody>
      </table>

      <div *ngIf="bundle.PRODUCTS?.length === 0" style="font-size: small; color: #666; padding: 10px;">
        No products available.
      </div>
    </div>

    <!-- Save Button -->
    <div style="margin-top: 20px; padding-left: 15px; text-align: right;">
      <button type="button"
              (click)="onSave()"
              style="padding: 6px 18px; font-size: small; cursor: pointer;">
        Save
      </button>
    </div>

  </div>
</div>
